import React, { memo } from 'react';
import { Select } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import { dspxGetChildrens } from '../../../../../../helpers/dspx-utils';
import { ReactComponent as AddressFilterIcon } from '../../../../../../resource/AddressFilterIcon.svg';
import SelectRoomsRow from '../../controls/SelectRoomsRow';
import SelectStreetHouse from '../../controls/SelectStreetHouse';
import {
  hasFilterValue,
  selectAddressActiveCount,
} from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { requestFilterSectionIds } from '../../../model/sectionExpansion';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FilterSection from '../../primitives/FilterSection';
import { multiSelectTagProps } from '../../primitives/selectTagProps';
import styles from './AddressFilterSection.module.scss';

const selectAddressFilterState = (state) => {
  const filter = state.filterStore;

  return {
    valueDistrict: filter.valueDistrict,
    valueAddrStreet: filter.valueAddrStreet,
    valueAddrBuilding: filter.valueAddrBuilding,
    valueAddrPorch: filter.valueAddrPorch,
    valueAddrFloor: filter.valueAddrFloor,
    valueAddrTypeFlat: filter.valueAddrTypeFlat,
    valueAddrFlat: filter.valueAddrFlat,
    filterDistrict: filter.filterDistrict,
  };
};

const AddressFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const filter = useSelector(selectAddressFilterState, shallowEqual);
  const activeCount = useSelector(selectAddressActiveCount);
  const { changeFilter } = useFilterChange();

  const addressActive =
    hasFilterValue(filter.valueAddrStreet) ||
    hasFilterValue(filter.valueAddrBuilding);
  const roomsActive =
    hasFilterValue(filter.valueAddrPorch) ||
    hasFilterValue(filter.valueAddrFloor) ||
    hasFilterValue(filter.valueAddrTypeFlat) ||
    hasFilterValue(filter.valueAddrFlat);

  return (
    <FilterSection
      sectionId={requestFilterSectionIds.address}
      heading="Адрес"
      description="Район, дом и параметры помещения"
      icon={<AddressFilterIcon />}
      activeCount={activeCount}
    >
      <div className={styles.content}>
        <FilterField
          label="Район"
          active={hasFilterValue(filter.valueDistrict)}
        >
          <Select
            {...multiSelectTagProps}
            mode="multiple"
            defaultActiveFirstOption={false}
            allowClear={true}
            placeholder="Выберите район"
            notFoundContent="нет данных"
            value={filter.valueDistrict}
            onChange={(value) => {
              changeFilter(filterCommands.applyDistrict(value));
            }}
            optionFilterProp="searchtext"
          >
            {dspxGetChildrens(filter.filterDistrict)}
          </Select>
        </FilterField>

        <FilterField
          label="Улица и дом"
          active={addressActive}
          className={styles.fullWidth}
        >
          <div className={styles.addressControls}>
            <SelectStreetHouse
              onChangeStreet={(value) => {
                changeFilter(filterCommands.applyAddrStreet(value));
              }}
              onChangeHouse={(value) => {
                changeFilter(filterCommands.applyAddrBuilding(value));
              }}
            />
          </div>
        </FilterField>

        <FilterField
          label="Подъезды, этажи и помещения"
          active={roomsActive}
          className={styles.fullWidth}
        >
          <div className={styles.roomControls}>
            <SelectRoomsRow />
          </div>
        </FilterField>
      </div>
    </FilterSection>
  );
};

export default memo(AddressFilterSection);
